import React from 'react'
import {
  Form, Icon, Input, Button, Checkbox, message
} from 'antd'
import axios from 'axios'
import './login.less'
import { withRouter } from 'react-router-dom'
import common from '../../public/common'
import logo from '../../logo.svg'
import { ajaxApi } from '../../server/index'
import {
  setCookie, md5hex
} from '../../public/utils'

const FormItem = Form.Item
class NormalLoginForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false
    }
  }
  handleSubmit = (e) => {
    const that = this
    e.preventDefault()
    that.props.form.validateFields(async (err, values) => {
      if (err) {
        console.error(err)
      }
      try {
        const postData = { userName: values.userName, password: md5hex(values.password) }
        const response = await axios({
          method: 'post',
          url: common.new_net_to_java + `login/userlogin`,
          data: postData,
          headers: {
            token: '2B73C1A9955B4A5E27DEFCB2A51AF08B'
          },
          withCredentials: false
        })
        if (response.data.loginResult === true) {
          message.success('登录成功')
          window.localStorage.setItem('token', response.data.token)
          setCookie('login_username', values.userName, 30)
          setCookie('login_password', md5hex(values.password), 30)
          that.props.history.push('/main/home')
        }
      } catch (res) {
        console.log(res)
        if (res.response && res.response.status !== 200) {
          message.error(res.response.data.error_msg || res.response.data.message)
        } else {
          message.error('请检查网络链接')
        }
      }
      // ajaxApi(`${common.base_url}login/userlogin`, postData, (response) => {
      //   if (response.loginresult === true) {
      //     message.success('登录成功');
      //     window.localStorage.setItem('token', response.token);
      //     setCookie('login_username', values.userName, 30);
      //     setCookie('login_password', md5hex(values.password), 30);
      //     that.props.history.push('/main/home');
      //   } else {
      //     message.error('登录失败');
      //   }
      //   that.setState({ loading: false });
      // });
      // }
    })
  }

  render () {
    const { getFieldDecorator } = this.props.form
    return (
      <div className="login-body">
        <div className="login-page">
          <div className="login-header">
            <img src={logo} alt="logo" className="login-logo" />
            <span className="login-title">
              视客眼镜网管理系统
            </span>
          </div>
          <div>
            <Form onSubmit={this.handleSubmit} className="login-form">
              <FormItem>
                {getFieldDecorator('userName', {
                  rules: [{ required: true, message: '请输入用户名!' }]
                })(
                  <Input prefix={<Icon type="user" style={{ fontSize: 13 }} />} placeholder="用户名" size="large" />
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('password', {
                  rules: [{ required: true, message: '请输入密码!' }]
                })(
                  <Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="password" placeholder="密码" size="large" />
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('remember', {
                  valuePropName: 'checked',
                  initialValue: true
                })(
                  <Checkbox>自动登录</Checkbox>
                )}
                <a href="" className="forget-pwd">忘记密码
                </a>
              </FormItem>
              <FormItem>
                <Button loading={this.state.loading} type="primary" htmlType="submit" size="large" className="loginButton">
                  登录
                </Button>
              </FormItem>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

const WrappedNormalLoginForm = withRouter(Form.create()(NormalLoginForm))

class Login extends React.Component {
  render () {
    return (
      <WrappedNormalLoginForm />
    )
  }
}
export default withRouter(Login)



// WEBPACK FOOTER //
// ./src/pages/login/login.js